import {TabsConfig} from "@backstage/plugin-techdocs";


export const techdocsTabs = () : TabsConfig  => {
  return [
    {
      label: "Onboarding",
      panels: [
        {
          title: "OnBoarding Documentation",
          description: "OnBoarding documentation on what standards to follow and refer to",
          panelType: "DocsCardGrid",
          filterPredicate: entity => {
            const isDomain = entity.kind.toLowerCase() === 'domain'
            const tagsContainsOnboarding = entity?.metadata?.tags?.includes('documentation') ?? false
            return isDomain && tagsContainsOnboarding
          }
        }
      ]
    },
    {
      label: "Component Documentation",
      panels: [
        {
          title: "Component Documentation",
          description: "Techdocs documentation of individual components in LeoVegas",
          panelType: "DocsTable",
          filterPredicate: entity => entity.kind.toLowerCase() === "component"
        }
      ]
    }
  ]
}